import { Box, Button, Grid, Link, Typography } from '@mui/material';
import ButtonCTAOnboarding from './components/ButtonCTAOnboarding';
import OnboardingInput from './components/OnboardingInput';
import TestimonialsCarousel from './components/TestimonialsCarousel';

export const ForgotPasswordOnboarding = () => {
  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          position: 'relative',
        }}
      >
        <Box sx={{ position: 'absolute', top: 32, left: 32 }}>
          <img
            src="/icon/artwork.svg"
            alt=""
            style={{
              width: 120,
              height: 'auto',
            }}
          />
        </Box>
        <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
          }}
        >
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="h5"
            fontWeight={700}
            mb={2}
            mt={2}
            align="center"
            sx={{ width: '100%' }}
          >
            Forgot password
          </Typography>
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="subtitle1"
            fontWeight={400}
            mb={4}
            align="center"
            sx={{ width: '100%' }}
          >
            Enter your email address to reset your password
          </Typography>
          <Box sx={{ width: '100%', mb: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{ mb: 0.5, color: '#fff', fontWeight: 500 }}
            >
              Email
            </Typography>
            <OnboardingInput placeholder="matheus.@oppy.pro" margin="normal" />
          </Box>

          <ButtonCTAOnboarding
            label="Send reset password email"
            onClick={() => {}}
          />
          <Typography variant="body2" mt={3} textAlign="center" color="#fff">
            Have a login and password?{' '}
            <Link href="#" color="#4949C8" underline="hover">
              Sign in
            </Link>
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 600, textAlign: 'center', mb: 0 }}>
          <Typography
            variant="h5"
            fontFamily="Space Grotesk"
            fontWeight={700}
            color="#4949C8"
            sx={{ mb: 1 }}
          >
            Oppy's AI assistants handle <br /> your daily tasks…
          </Typography>
          <Typography variant="subtitle1" color="#222" sx={{ mb: 4 }}>
            so you can focus on showing homes, closing <br /> deals, and
            building relationships.
          </Typography>
        </Box>
        <TestimonialsCarousel />
      </Grid>
    </Grid>
  );
};
